/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../ui-elements/spinner/spinner.component.ngfactory';
import * as import4 from '../../ui-elements/spinner/spinner.component';
import * as import5 from '@angular/common';
import * as import6 from '../../ui-elements/logo/logo.component.ngfactory';
import * as import7 from '../../ui-elements/logo/logo.component';
import * as import8 from '../../ordering-context/ordering-context.model';
import * as import9 from '../order-details-panel/order-details-panel.component.ngfactory';
import * as import10 from '../order-details-panel/order-details-panel.component';
import * as import11 from '../../orchestration/session.model';
import * as import12 from '../order.model';
import * as import13 from '../../orchestration/navigation.service';
import * as import14 from '../../page-layout/page-header-image/page-header-image.component.ngfactory';
import * as import15 from '../../page-layout/page-header-image/page-header-image.component';
import * as import16 from '../../orchestration/responsive.directive';
import * as import17 from '../../orchestration/responsive.service';
import * as import18 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import19 from '../../ui-elements/icon/icon.component';
import * as import20 from '../../notification/message/message.component.ngfactory';
import * as import21 from '../../notification/message/message.component';
import * as import22 from '../../notification/notification.service';
import * as import23 from '../../html-utils/element-width.directive';
import * as import24 from '../../ui-elements/chewzie-logo/chewzie-logo.component.ngfactory';
import * as import25 from '../../ui-elements/chewzie-logo/chewzie-logo.component';
import * as import26 from '../../buttons/button/button.component.ngfactory';
import * as import27 from '../../buttons/button/button.component';
import * as import28 from '../../page-layout/page-footer-control.directive';
import * as import29 from '../../html-utils/html.pipe';
import * as import30 from '@angular/platform-browser';
import * as import31 from '../../string-utils/possessive.pipe';
import * as import32 from './order-confirmation-page.component';
import * as import33 from '../../page-layout/full-page-layout/full-page-layout.component.ngfactory';
import * as import34 from '../../page-layout/full-page-layout/full-page-layout.component';
import * as import35 from '../../orchestration/page';
import * as import36 from '../../theme/theme.model';
import * as import37 from '../../orchestration/navigation-params';
import * as import38 from '../../orchestration/session.controller';
import * as import39 from '../../orchestration/analytics.service';
import * as import40 from '../../customer-info/customer-details.service';
const styles_OrderConfirmationPageComponent:any[] = ([] as any[]);
export const RenderType_OrderConfirmationPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderConfirmationPageComponent,
  data: {}
}
);
function View_OrderConfirmationPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'acceptance-pending-phase1'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'acceptance-pending-phase1-message'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',[[
        'class',
        'acceptance-pending-phase1-spinner'
      ]
    ],(null as any),(null as any),(null as any),import3.View_SpinnerComponent_0,import3.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import4.SpinnerComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,4,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),import0.ɵunv(v,2,0,import0.ɵnov(v,3).transform('woa.message.order.placement.pendingPhase1'))));
    ck(v,2,0,currVal_0);
  });
}
function View_OrderConfirmationPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'acceptance-pending-phase2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'acceptance-pending-phase2-message'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,':svg:svg',[[
        'class',
        'acceptance-pending-phase2-progress'
      ]
    ],[
      [
        1,
        'height',
        0
      ]
      ,
      [
        1,
        'width',
        0
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'class',
        'acceptance-pending-phase2-progress-circle'
      ]
      ,
      [
        'fill',
        'transparent'
      ]

    ]
    ,[
      [
        1,
        'stroke-width',
        0
      ]
      ,
      [
        1,
        'r',
        0
      ]
      ,
      [
        1,
        'cx',
        0
      ]
      ,
      [
        1,
        'cy',
        0
      ]
      ,
      [
        4,
        'strokeDasharray',
        (null as any)
      ]
      ,
      [
        4,
        'strokeDashoffset',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,4,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),import0.ɵunv(v,2,0,import0.ɵnov(v,3).transform('woa.message.order.placement.pendingPhase2'))));
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.progressSize;
    const currVal_2:any = co.progressSize;
    ck(v,6,0,currVal_1,currVal_2);
    const currVal_3:any = co.progressStrokeWidth;
    const currVal_4:any = co.progressRadius;
    const currVal_5:any = (co.progressSize / 2);
    const currVal_6:any = (co.progressSize / 2);
    const currVal_7:any = ((co.progressCircumference + ' ') + co.progressCircumference);
    const currVal_8:any = co.progressOffset;
    ck(v,9,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_OrderConfirmationPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'acceptance-pending'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.pendingPhase === 1);
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.pendingPhase === 2);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_OrderConfirmationPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'acceptance-cancelled'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'acceptance-cancelled-message'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,2,0,import0.ɵnov(v,3).transform('woa.message.order.placement.cancelled'))));
    ck(v,2,0,currVal_0);
  });
}
function View_OrderConfirmationPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'acceptance-rejected'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'acceptance-rejected-message'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),import0.ɵunv(v,2,0,import0.ɵnov(v,3).transform('woa.message.order.placement.rejected'))));
    ck(v,2,0,currVal_0);
  });
}
function View_OrderConfirmationPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'acceptance'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'acceptance-logo logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'vertical';
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.recentOrder.placedOrder.status === co.OrderPlacementStatus.PENDING);
    ck(v,6,0,currVal_1);
    const currVal_2:any = (co.recentOrder.placedOrder.status === co.OrderPlacementStatus.CANCELLED);
    ck(v,9,0,currVal_2);
    const currVal_3:any = (co.recentOrder.placedOrder.status === co.OrderPlacementStatus.REJECTED);
    ck(v,12,0,currVal_3);
  },(null as any));
}
function View_OrderConfirmationPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[
      [
        'class',
        'order-details'
      ]
      ,
      [
        'slot',
        'content-left'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-details-panel',([] as any[]),(null as any),(null as any),(null as any),import9.View_OrderDetailsPanelComponent_0,import9.RenderType_OrderDetailsPanelComponent)),
    import0.ɵdid(573440,(null as any),0,import10.OrderDetailsPanelComponent,[
      import11.SessionModel,
      import8.OrderingContextModel,
      import12.OrderModel,
      import13.NavigationService
    ]
    ,{
      recentOrder: [
        0,
        'recentOrder'
      ]
      ,
      showFulfilmentDetails: [
        1,
        'showFulfilmentDetails'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recentOrder;
    const currVal_1:any = false;
    ck(v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_OrderConfirmationPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-page-header-image',[
      [
        'class',
        'order-placement-summary-store-image'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),import14.View_PageHeaderImageComponent_0,import14.RenderType_PageHeaderImageComponent)),
    import0.ɵdid(245760,(null as any),0,import15.PageHeaderImageComponent,[
      import11.SessionModel,
      import8.OrderingContextModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    import0.ɵdid(737280,(null as any),0,import16.ResponsiveDirective,[
      import0.ElementRef,
      import17.ResponsiveService,
      import13.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
    ck(v,2,0);
  },(null as any));
}
function View_OrderConfirmationPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[
      [
        'class',
        'order-placement-summary-icon'
      ]
      ,
      [
        'name',
        'check-circle'
      ]

    ]
    ,(null as any),(null as any),(null as any),import18.View_IconComponent_0,import18.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import19.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'check-circle';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_OrderConfirmationPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-content-message',[[
        'class',
        'order-placement-summary-heading-notice'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import20.View_ContentMessageComponent_0,import20.RenderType_ContentMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import21.ContentMessageComponent,[
      import0.ElementRef,
      import22.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,3,{links: 1}),
    import0.ɵpod(['name'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.SUCCESS;
    const currVal_9:any = co.headingNotice;
    const currVal_10:any = ck(v,3,0,co.firstName);
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderConfirmationPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),35,'div',[
      [
        'class',
        'order-placement'
      ]
      ,
      [
        'slot',
        'content-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[
      [
        'class',
        'order-placement-summary'
      ]
      ,
      [
        'woa-element-width',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(5455872,(null as any),0,import23.ElementWidthDirective,[
      import0.ElementRef,
      import0.ChangeDetectorRef,
      import17.ResponsiveService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'order-placement-summary-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'order-placement-summary-heading-title'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵpod([
      'name',
      'table',
      'groupOrderName'
    ]
    ),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderConfirmationPageComponent_11)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'order-placement-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-order-details-panel',([] as any[]),(null as any),(null as any),(null as any),import9.View_OrderDetailsPanelComponent_0,import9.RenderType_OrderDetailsPanelComponent)),
    import0.ɵdid(573440,(null as any),0,import10.OrderDetailsPanelComponent,[
      import11.SessionModel,
      import8.OrderingContextModel,
      import12.OrderModel,
      import13.NavigationService
    ]
    ,{
      recentOrder: [
        0,
        'recentOrder'
      ]
      ,
      showFulfilmentDetails: [
        1,
        'showFulfilmentDetails'
      ]
      ,
      showLocationDetails: [
        2,
        'showLocationDetails'
      ]
      ,
      showOrderDetails: [
        3,
        'showOrderDetails'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-chewzie-logo',[[
        'class',
        'order-placement-logo'
      ]
    ],(null as any),(null as any),(null as any),import24.View_ChewzieLogoComponent_0,import24.RenderType_ChewzieLogoComponent)),
    import0.ɵdid(49152,(null as any),0,import25.ChewzieLogoComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,3,0);
    const currVal_0:any = co.orderingContextModel.headerImage;
    ck(v,6,0,currVal_0);
    const currVal_1:boolean = !co.orderingContextModel.headerImage;
    ck(v,9,0,currVal_1);
    const currVal_3:any = co.headingNotice;
    ck(v,21,0,currVal_3);
    const currVal_4:any = co.recentOrder;
    const currVal_5:boolean = !co.recentOrder.orderInitiation.transferTargetId;
    const currVal_6:any = import0.ɵunv(v,28,2,import0.ɵnov(v,29).transform(co.responsiveService.mobile$));
    const currVal_7:any = import0.ɵunv(v,28,3,import0.ɵnov(v,30).transform(co.responsiveService.mobile$));
    ck(v,28,0,currVal_4,currVal_5,currVal_6,currVal_7);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import0.ɵunv(v,13,0,ck(v,17,0,import0.ɵnov((<any>v.parent),0),import0.ɵunv(v,13,0,import0.ɵnov(v,16).transform(co.headingTitle,ck(v,15,0,co.firstName,co.recentOrder.orderInitiation.tableNumber,import0.ɵunv(v,13,0,ck(v,14,0,import0.ɵnov((<any>v.parent),1),co.recentOrder.orderInitiation.transferTargetName)))))));
    ck(v,13,0,currVal_2);
  });
}
function View_OrderConfirmationPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.done()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import26.View_ButtonComponent_0,import26.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import27.ButtonComponent,[
      import0.ElementRef,
      import11.SessionModel,
      import0.ChangeDetectorRef,
      import17.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        2,
        4
      ]
    ],0,import28.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_27:any = 'woa.button.common.done';
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_OrderConfirmationPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.back()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import26.View_ButtonComponent_0,import26.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import27.ButtonComponent,[
      import0.ElementRef,
      import11.SessionModel,
      import0.ChangeDetectorRef,
      import17.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        2,
        4
      ]
    ],0,import28.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    const currVal_27:any = 'woa.button.order.return';
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export function View_OrderConfirmationPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import29.HtmlPipe,[import30.DomSanitizer]),
    import0.ɵpid(0,import31.PossessivePipe,([] as any[])),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'woa-full-page-layout',([] as any[]),(null as any),[[
        (null as any),
        'onBack'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import32.OrderConfirmationPageComponent = v.component;
      if (('onBack' === en)) {
        const pd_0:any = ((<any>co.back()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import33.View_FullPageLayoutComponent_0,import33.RenderType_FullPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),1,import34.FullPageLayoutComponent,[
      import35.Page,
      import13.NavigationService,
      import17.ResponsiveService,
      import36.ThemeModel
    ]
    ,{
      showNavbarLogo: [
        0,
        'showNavbarLogo'
      ]
      ,
      autoDismissOnBack: [
        1,
        'autoDismissOnBack'
      ]
      ,
      hideBackButton: [
        2,
        'hideBackButton'
      ]
      ,
      showBackButtonOnDesktop: [
        3,
        'showBackButtonOnDesktop'
      ]
      ,
      pillarboxedOnDesktop: [
        4,
        'pillarboxedOnDesktop'
      ]

    }
    ,{onBack: 'onBack'}),
    import0.ɵqud(603979776,2,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import35.PageLayout,(null as any),[import34.FullPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OrderConfirmationPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),3,2,(null as any),View_OrderConfirmationPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),5,1,(null as any),View_OrderConfirmationPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_OrderConfirmationPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_OrderConfirmationPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import32.OrderConfirmationPageComponent = v.component;
    const currVal_0:any = true;
    const currVal_1:any = false;
    const currVal_2:any = co.hideBackButton;
    const currVal_3:any = true;
    const currVal_4:any = ((co.recentOrder.placedOrder.status === co.OrderPlacementStatus.ACCEPTED)? 'double-mobile': 'mobile');
    ck(v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = (co.recentOrder.placedOrder.status !== co.OrderPlacementStatus.ACCEPTED);
    ck(v,9,0,currVal_5);
    const currVal_6:any = ((co.recentOrder.placedOrder.status === co.OrderPlacementStatus.ACCEPTED) && import0.ɵunv(v,12,0,import0.ɵnov(v,13).transform(co.responsiveService.desktop$)));
    ck(v,12,0,currVal_6);
    const currVal_7:any = (co.recentOrder.placedOrder.status === co.OrderPlacementStatus.ACCEPTED);
    ck(v,16,0,currVal_7);
    const currVal_8:any = (co.recentOrder.placedOrder.status === co.OrderPlacementStatus.ACCEPTED);
    ck(v,19,0,currVal_8);
    const currVal_9:any = ((co.recentOrder.placedOrder.status !== co.OrderPlacementStatus.PENDING) && (co.recentOrder.placedOrder.status !== co.OrderPlacementStatus.ACCEPTED));
    ck(v,22,0,currVal_9);
  },(null as any));
}
function View_OrderConfirmationPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-order-confirmation-page',([] as any[]),(null as any),(null as any),(null as any),View_OrderConfirmationPageComponent_0,RenderType_OrderConfirmationPageComponent)),
    import0.ɵdid(245760,(null as any),0,import32.OrderConfirmationPageComponent,[
      import37.NavigationParams,
      import11.SessionModel,
      import8.OrderingContextModel,
      import12.OrderModel,
      import13.NavigationService,
      import38.SessionController,
      import17.ResponsiveService,
      import39.AnalyticsService,
      import0.ChangeDetectorRef,
      import40.CustomerDetailsService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import35.Page,(null as any),[import32.OrderConfirmationPageComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const OrderConfirmationPageComponentNgFactory:import0.ComponentFactory<import32.OrderConfirmationPageComponent> = import0.ɵccf('woa-order-confirmation-page',import32.OrderConfirmationPageComponent,View_OrderConfirmationPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-confirmation-page/order-confirmation-page.component.ngfactory.ts